module.exports = __webpack_public_path__ + "img/industry1.74b4cd98.png";